exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorWrap___2FEG4 {\n  position: relative;\n  height: 100vh;\n}\n.errorContentWrap___1BFSB {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.errorImg___1KlYa {\n  width: 2.55rem;\n  height: 1.63rem;\n  background-image: url(https://image-1253289665.picsh.myqcloud.com/2021/09/08/a3defc9951e3223f6de35f3c816b34ea.png);\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n.errorText___1bzG3 {\n  margin-top: 0.2rem;\n  font-size: 0.14rem;\n  color: #999;\n}\n", ""]);

// exports
exports.locals = {
	"errorWrap": "errorWrap___2FEG4",
	"errorContentWrap": "errorContentWrap___1BFSB",
	"errorImg": "errorImg___1KlYa",
	"errorText": "errorText___1bzG3"
};